import ProviderCommonApi from '../../../API/provider/common-api';
import KomusApi from '../../../API/provider/komus-api';
import { Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import ProviderProductsTable from '../../../components/Providers/Blocks/ProductsTable';
import ProviderDasboardContentWhiteBlock from '../../../components/Providers/Blocks/ProviderDasboardContent';
import ProviderUpdateStatusBlock from '../../../components/Providers/Blocks/ProviderUpdateStatus';
import { PROVIDERS, TYPE_BUTTONS } from '../../../constans';


const KomusPage = ({ ...props }) => {

  const updateStocks = async () => {
    KomusApi.updateStocks({})
  };

  let providerId = PROVIDERS.KOMUS.id;

  const updateData = () => {
    KomusApi.updateProducts({})
  };

  return (
    <>
      <Content>
        <Row style={{ alignItems: 'unset' }}>
          <WhiteBlock style={{ marginRight: '15px' }}>
            <Row style={{ marginBottom: '15px' }}>
              <Button type={TYPE_BUTTONS.BLUE} onClick={updateStocks} style={{ marginRight: '15px' }}>
                Обновить остатки
              </Button>
              <Button type={TYPE_BUTTONS.RED} onClick={() => ProviderCommonApi.nullStocks({ data: { providerId } })} style={{ marginRight: '15px' }}>
                Обнулить остатки
              </Button>
              <Button type={TYPE_BUTTONS.BLUE} onClick={updateData} style={{ marginRight: '15px' }}>
                Выгрузить данные
              </Button>
            </Row>
            <ProviderUpdateStatusBlock providerId={providerId} />
          </WhiteBlock>

          <ProviderDasboardContentWhiteBlock providerId={providerId} isLoadImage={true} />
        </Row>
        <ProviderProductsTable providerId={providerId} isCityStocks={true} />
      </Content>
    </>
  );
};

export default KomusPage;
